import { Link, useLocation } from "react-router-dom";
import {Leaf} from 'lucide-react';

export default function Navigation() {
  const location = useLocation();

  const navLinks = [
    { path: "/", label: "Home" },
    { path: "/business", label: "Business Calculator" },
    { path: "/science", label: "Learn the Science" },
    { path: "/lifestyle", label: "Household & Lifestyle" },
  ];

  return (
    <nav className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="bg-[#2E8B57] p-2 rounded-lg group-hover:bg-[#267347] transition-colors">
              <Leaf className="w-6 h-6 text-white" />
            </div>
            <span className="text-lg font-semibold text-gray-900">
              GHG Calculator
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors ${
                  location.pathname === link.path
                    ? "text-[#2E8B57]"
                    : "text-gray-600 hover:text-[#2E8B57]"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <button className="md:hidden text-gray-600">
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
        </div>
      </div>
    </nav>
  );
}
